import { Div } from '@vgrubs/components';
import styled from 'styled-components';

const SpinnerStyled = styled.div<StyledProps>`
  z-index: ${({ $noZIndex }) => ($noZIndex ? 0 : 200)};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme, $creme, $noBackground }) =>
    $noBackground
      ? 'transparent'
      : ($creme ? theme.background : theme.white) + theme.transparency.t50};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ $overflowBorderRadius }) => $overflowBorderRadius};

  ${({ $isRootPage }) =>
    $isRootPage &&
    `
    left: 250px;
    @media (max-width: 1200px) {
    left: 0;
  }
     `}

  ${({ $absolute }) =>
    $absolute &&
    `
    position: absolute;
  `}

  ${({ $noOverlay }) =>
    $noOverlay &&
    `
    position: relative;
  `}

  @keyframes ldio-4ro331xvst8 {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
  .ldio-4ro331xvst8 div {
    position: absolute;
    width: 46.98px;
    height: 46.98px;
    border: 5.22px solid
      ${({ theme, $spinnerColor }) => $spinnerColor || theme.primary};
    border-top-color: transparent;
    border-radius: 50%;
  }
  .ldio-4ro331xvst8 div {
    animation: ldio-4ro331xvst8 0.5681818181818182s linear infinite;
    top: 50px;
    left: 50px;
  }
  .loadingio-spinner-rolling-t61fu8i5jyi {
    ${({ $small }) => $small && 'transform: scale(0.7);'}
    ${({ $smallest }) => $smallest && 'transform: scale(0.4);'}

    width: 100px;
    height: 100px;
    ${({ $noOverlay }) =>
      $noOverlay &&
      `
    // width: 50px;
    // height: 50px;
  `}
    display: inline-block;
    overflow: hidden;
  }
  .ldio-4ro331xvst8 {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
  }
  .ldio-4ro331xvst8 div {
    box-sizing: content-box;
  }
  /* generated by https://loading.io/ */
`;

export const AdminSpinner = ({
  absolute,
  small,
  smallest,
  noOverlay,
  creme,
  overflowBorderRadius,
  $noBackground,
  $noZIndex,
  isRootPage,
  $spinnerColor,
}: Props) => {
  return (
    <SpinnerStyled
      $absolute={absolute}
      $small={small}
      $smallest={smallest}
      $noOverlay={noOverlay}
      $creme={creme}
      $overflowBorderRadius={overflowBorderRadius}
      $noBackground={$noBackground}
      $noZIndex={$noZIndex}
      $isRootPage={isRootPage}
      $spinnerColor={$spinnerColor}
    >
      <div className="loadingio-spinner-rolling-t61fu8i5jyi">
        <div className="ldio-4ro331xvst8">
          <div></div>
        </div>
      </div>
    </SpinnerStyled>
  );
};

export const ListSpinner = ({
  loading,
  observerRef,
  smallest,
  mb,
  mbSM,
  height,
  heightSM,
}: {
  loading: boolean;
  observerRef?: React.Ref<HTMLDivElement>;
  smallest?: boolean;
  /** The negative defaults tuck it under a page's last row; a list inside a
   *  modal passes "0", or the spinner sinks into the modal's padding. `mb`
   *  covers the phone too unless `mbSM` says otherwise. */
  mb?: string;
  mbSM?: string;
  height?: string;
  heightSM?: string;
}) => {
  return (
    <Div
      ref={observerRef}
      $relative
      $height={height || '70px'}
      $heightSM={heightSM || '70px'}
      $mb={mb || '-40'}
      $mbSM={mbSM || mb || '-32'}
    >
      {loading && (
        <AdminSpinner
          absolute
          small={!smallest}
          smallest={smallest}
          $noBackground
        />
      )}
    </Div>
  );
};

type StyledProps = {
  $creme?: boolean;
  $absolute?: boolean;
  $noOverlay?: boolean;
  $small?: boolean;
  $smallest?: boolean;
  $overflowBorderRadius?: string;
  $noBackground?: boolean;
  $noZIndex?: boolean;
  $isRootPage?: boolean;
  $spinnerColor?: string;
};

type Props = {
  creme?: boolean;
  absolute?: boolean;
  noOverlay?: boolean;
  small?: boolean;
  overflowBorderRadius?: string;
  smallest?: boolean;
  $noBackground?: boolean;
  $noZIndex?: boolean;
  isRootPage?: boolean;
  $spinnerColor?: string;
};
